import { useAuth } from '../../context/AuthContext'
import { PERMISSION_KEYS } from '../../config/permissions'
import { PageHeader, PageShell } from '../../components/ui'
import { cardClass, cn, pageLeadClass } from '../../lib/ui'

/** Стартовая страница администрирования — без дублирования списков из других вкладок. */
export function AdminHomePage() {
  const { user, can } = useAuth()

  const hasAnySection =
    can(PERMISSION_KEYS.USERS_READ) ||
    can(PERMISSION_KEYS.ROLES_READ) ||
    can(PERMISSION_KEYS.CONSUMABLES_READ) ||
    can(PERMISSION_KEYS.PRODUCTS_READ) ||
    can(PERMISSION_KEYS.MACHINES_READ)

  return (
    <PageShell className="max-w-md">
      <PageHeader
        title="Панель"
        lead="Управление пользователями, ролями и деревьями категорий. Выберите раздел в меню слева."
      />

      <div className={cn(cardClass, 'max-w-md')}>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Текущий пользователь</p>
        <p className="mt-1 text-lg font-semibold text-su-text-strong">{user?.email ?? '—'}</p>
        <p className="mt-1 text-sm text-su-text">
          Роль: <strong>{user?.roleName ?? '—'}</strong>
          {user?.expand?.role?.title ? ` (${user.expand.role.title})` : ''}
        </p>
      </div>

      {!hasAnySection && (
        <p className={pageLeadClass}>У вашей роли нет прав на разделы администрирования.</p>
      )}
    </PageShell>
  )
}
